import * as React from "react";
import OtpInput from 'react-otp-input';
import { Button, Form, GridRow, Header, Image, Segment } from "semantic-ui-react";

import configs from "../helpers/config";
import LinkButton from "./LinkButton";
import { showMessage } from '../helpers/helper';
import loginService from "../services/login.service";

class LoginPaciente extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chave: '',
            code: '',
            status: 0,
            loading: false,
            //status: 1,
            //tamanho: 6,
            //tempoEspera: 255,
            //tempoEsperaReenvio: 45
        };
    }

    handleGenerateCode = () =>
        this.setState({ loading: true }, () =>
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: "PortalResultadosLoginPaciente" })
                    .then(async recaptcha_token => {
                        const { message, celular, tamanho, tempoEspera, tempoEsperaReenvio } = await loginService.loginAsync({
                            recaptcha_token,
                            chave: this.state.chave
                        });

                        if (message) {
                            showMessage(message);
                        } else {
                            if (this.timeout)
                                clearTimeout(this.timeout);

                            this.setState({
                                code: '', status: 1, loading: false,
                                celular, tamanho, tempoEspera, tempoEsperaReenvio
                            }, this.handleUpdateTimers)
                        }
                    });
            }));

    handleUpdateTimers = () => {
        const { tempoEspera, tempoEsperaReenvio } = this.state;

        if (tempoEspera > 0) {
            this.timeout = setTimeout(() => {
                this.setState({
                    tempoEspera: tempoEspera - 1,
                    tempoEsperaReenvio: tempoEsperaReenvio - 1
                }, this.handleUpdateTimers);
            }, 1000);
        } else {
            this.setState(state => ({
                ...state,
                chave: '',
                code: '',
                status: 0
            }));
        }
    }

    handleLogin = () => {
        const { chave, status, code } = this.state;

        if (chave) {
            if (status === 0) {
                this.handleGenerateCode();
            } else {
                this.setState({ loading: true }, () =>
                    window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: "PortalResultadosLoginPaciente" })
                        .then(recaptcha_token => {
                            this.setState({
                                chave: '',
                                code: '',
                                status: 1
                            }, async () => {
                                clearTimeout(this.timeout);

                                await this.props.onClick({
                                    chave,
                                    code,
                                    recaptcha_token
                                });

                                this.setState({
                                    status: 0,
                                    loading: false,
                                });
                            });
                        })
                );
            }
        } else {
            showMessage("Insira a os dados de acesso corretamente");
        }
    }

    avisado = false;
    handleDocumento = (e) => {
        const valor = e.target.value.replace(/\D+/g, "");
        const cpf = valor.length <= 11;//Login por CPF ou documento estrangeiro, chave de acess tem 12 caracteres
        //if (!cpf && valor.length > 11 && !this.avisado) {
        //    showMessage(
        //        "Parece que você está tentando digitar uma chave de acesso." +
        //        "\r\nPara realizar o login faça o registro do seu usuário através do botão \"Não tenho cadastro\""
        //    )
        //    this.avisado = true;
        //}
        this.setState({ cpf, chave: e.target.value });
    };

    handleEmail = (e) => {
        const email = e.target.value.indexOf("@") > 0;
        this.setState({ email, chave: e.target.value });
    };

    handleData = (e) => {
        let value = e.target.value;

        if (!this.state.cpf) {
            value = e.target.value
                .replace(/\D+/g, "")
                .substr(0, 8)
                .replace(/(\d{2})(\d{2})(\d{4})/, "$1/$2/$3");
        }

        this.setState({ date: value });
    };

    formatTime = totalSeconds => {
        if (totalSeconds > 0) {
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;

            const mm = minutes.toString().padStart(2, '0');
            const ss = seconds.toString().padStart(2, '0');

            return `${mm}:${ss}`;
        }

        return '';
    }

    render() {
        return (
            <Segment className={this.props.className}>
                <Header as="h2">
                    <p className="headerLogin">
                        <Image src={require("../img/paciente.png")} size="small" verticalAlign="middle" className="imgLogoLogin" />
                        PACIENTE
                    </p>
                </Header>
                <Form size="large">
                    <GridRow>
                        {this.state.status === 0 ?
                            <Form.Input
                                fluid
                                icon="credit card outline"
                                iconPosition="left"
                                placeholder="CPF ou Documento (Estrangeiros)"
                                value={this.state.chave}
                                onChange={this.handleDocumento}
                            /> :
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                <p>DIGITE ABAIXO O NÚMERO QUE RECEBEU NO SEU CELULAR. EXPIRA EM {this.formatTime(this.state.tempoEspera)}</p>
                                <OtpInput
                                    value={this.state.code}
                                    numInputs={this.state.tamanho}
                                    onChange={code => this.setState({ code })}
                                    renderSeparator={<span>-</span>}
                                    renderInput={(props) => <input {...props} style={{ textAlign: 'center' }} />}
                                    onPaste={e => {
                                        const data = e.clipboardData.getData('text');

                                        if (data?.length === this.state.tamanho) {
                                            this.setState({ code: data })
                                        }
                                    }}
                                    placeholder={''.padStart(this.state.tamanho, '0')}
                                />
                                <span>Reenviar por SMS: {this.state.celular} </span>
                                <Button fluid size="large" onClick={this.handleGenerateCode}
                                    disabled={this.state.loading || this.state.tempoEsperaReenvio > 0}>
                                    REENVIAR {this.formatTime(this.state.tempoEsperaReenvio)}
                                </Button>
                            </div>
                        }
                        <br />
                        <Button fluid size="large" onClick={this.handleLogin}
                            disabled={this.state.loading || this.state.status === 1 && this.state.code.length !== this.state.tamanho}>
                            {this.state.loading ? 'AGUARDE' : this.state.status === 1 ? 'CONSULTAR RESULTADOS' : 'AVANÇAR'}
                        </Button>
                        <br />
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            {/* <LinkButton onClick={this.props.recuperar}>Esqueci minha senha</LinkButton> */}
                            {/* <LinkButton onClick={this.props.registrarPaciente} >Não tenho cadastro</LinkButton> */}
                        </div>
                    </GridRow>
                </Form>
            </Segment>
        );
    }
}
export default LoginPaciente;